import _ from "lodash";
import axios from "@util/axios";
import store from "@store";

class CompaniesService {
	constructor() {
		this.companies = store.getters.companies;
		this.company = store.getters.company;

		store.subscribe((mutation, state) => {
			this.user = state.auth.user;

			this.company = state.companies.company;
			this.companies = state.companies.companies;
		});
	}

	set(type = "company", data) {
		if ("list" === type)
			store.commit(
				"GET_COMPANIES",
				data
					? {
							count: data.length,
							results: data,
					  }
					: null
			);
		else
			store.commit(
				data && data.id === this.company.id
					? "UPDATE_COMPANY"
					: "READ_COMPANY",
				data
					? {
							data: data,
					  }
					: null
			);
	}

	async lightweight(params) {
		return await axios({
			url: `/company/lightweight/`,
			params: params || null,
		})
	}

	async list(params, commit = true) {
		const response = await axios({
			url: `/company/`,
			params: params || null,
		});

		if (commit) {
			store.commit("GET_COMPANIES", response.data.data);
		}

		return response;
	}

	async create(data, commit = true) {
		const response = await axios({
			url: `/company/`,
			method: "POST",
			data: _.pick(data, [
				"role_id",
				"name",
				"role_value",
				"status",
				"email_domain",
				"default_report_id",
				"fcp_role",
			]),
		});

		if (commit) {
			store.commit("CREATE_COMPANY", response.data.data);
			store.commit("READ_COMPANY", response.data.data);
		}

		return response;
	}

	async read(data, commit = true) {
		const response = await axios({
			url: `/company/${data.id}/`,
		});

		if (commit) store.commit("READ_COMPANY", response.data.data);

		return response;
	}

	async update(data, commit = true) {
		const response = await axios({
			url: `/company/${data.id}/`,
			method: "PUT",
			data: _.pick(data, [
				"role_id",
				"name",
				"role_value",
				"status",
				"email_domain",
				"default_report_id",
				"fcp_role",
                "cash_call_approver",
			]),
		});

		if (commit) {
			store.commit("UPDATE_COMPANY", response.data.data);

			if (data.id == response.data.data.data.id)
				store.commit("READ_COMPANY", response.data.data);
		}

		return response;
	}

	async delete(data, commit = true) {
		const response = await axios({
			url: `/company/${data.id}`,
			method: "DELETE",
		});

		if (commit)
			store.commit("DELETE_COMPANY", {
				data: data,
			});

		return response;
	}

	async deleteLogo(data) {
		const response = await axios({
			url: `/company/logo/${data.id}/`,
			method: "DELETE",
		});

		return response;
	}
}

export default new CompaniesService();
